import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { validEmail } from "../../Variables";
import { useContextStateManagement } from "../../context/ContextApi";
import InputMask from "react-input-mask";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import "./Auth.css";

export const Login = ({
  setIsTabClick,
  setCurrentRoute,
  setRegisterdUserToken,
  setRegisteredUserEmail,
  setUserDataAccess,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [emailMessage, setEmailMessage] = useState("");
  const [passwordMessage, setPasswordMessage] = useState("");
  const [qrCodeUrl, setQrCodeUrl] = useState();
  const [qrCodeMessage, setQrCodeMessage] = useState("");
  const [timeInSeconds, setTimeInSeconds] = useState(30);
  const { setOnBoardingRightsId, setRightsEnabled, setCredentialsSaved } =
    useContextStateManagement();
  const navigate = useNavigate();
  const location = useLocation();
  const hasSummaryTab =
    new URLSearchParams(location.search).get("tab") === "summary";

  // Remember whatever page the user was actually trying to reach (captured
  // by App.js as location.state.from when it bounced them to /login) so the
  // MFA/QR steps can send them back there instead of always landing on "/".
  const fromPath = location.state?.from;
  if (fromPath && !fromPath.startsWith("/login")) {
    sessionStorage.setItem("postLoginRedirect", fromPath);
  } else if (hasSummaryTab) {
    sessionStorage.setItem("postLoginRedirect", `/${location.search}`);
  }

  const getQRCode = async () => {
    await axios
      .get("/api/qrCodeUrl")
      .then((response) => {
        setQrCodeUrl(response.data.response.QRCodeUrl);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSubmit = async () => {
    const email = document.getElementById("userEmail");
    const pass = document.getElementById("userPassword");
    let isFieldEmpty = false;

    const user = {
      UserEmail: email.value,
      UserPassword: pass.value,
    };

    if (user.UserEmail === "") {
      email.classList.add("empty");
      isFieldEmpty = true;
      setEmailMessage("Enter your email");
    } else if (validEmail.test(user.UserEmail) === false) {
      email.classList.add("empty");
      isFieldEmpty = true;
      setEmailMessage("Enter a valid email");
    }

    if (user.UserPassword === "") {
      pass.classList.add("empty");
      isFieldEmpty = true;
      setPasswordMessage("Enter your password");
    }

    if (isFieldEmpty === true) return;

    if (validEmail.test(user.UserEmail) === true && user.UserPassword !== "") {
      axios
        .post("/api/login", user)
        .then((response) => {
          if (response) {
            setOnBoardingRightsId(1);
            setRightsEnabled(false);
            setRegisteredUserEmail(user.UserEmail);
            setRegisterdUserToken(response.data.token);
            setUserDataAccess(response.data);
            setIsTabClick(true);
            setCredentialsSaved(response.data.credentialsSaved);
            if (response.data.mfaEnabled === false) {
              setCurrentRoute("DeviceName");
              navigate("/DeviceName");
            } else {
              setCurrentRoute("VerifyMfa");
              navigate("/VerifyMfa");
            }
          }
        })
        .catch((error) => {
          if (error.response?.data?.error) {
            setPasswordMessage(error.response.data.error);
          } else if (error.response?.statusText) {
            setPasswordMessage("Server is not responding!");
          }
        });
    }
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === 13 || e.which === 13) handleSubmit();
  };

  const resetErrorFieldStyle = (e) => {
    if (e.target.classList.contains("empty")) {
      e.target.classList.remove("empty");
    }

    if (e.target.id === "userEmail") {
      setEmailMessage("");
    } else if (e.target.id === "qrCode") {
      setQrCodeMessage("");
    } else {
      setPasswordMessage("");
    }
  };

  const verifyQRCodeHandle = async () => {
    let qrCodeVal = document.getElementById("qrCode").value;
    qrCodeVal = qrCodeVal.toString().replace(/ /g, "");
    const qrCode = parseInt(qrCodeVal);

    if (qrCodeVal === "") {
      setQrCodeMessage("Enter 6-digit code");
      return;
    }

    axios
      .post("/api/verifyQRCode", { qrCode })
      .then((response) => {
        if (response) {
          setQrCodeMessage("");
        }
      })
      .catch(() => {
        setQrCodeMessage("Enter Correct 6-digit code");
      });
  };

  const regenerateQRCodeHandle = async () => {
    axios
      .post("/api/updateQRCode")
      .then(() => {
        if (document.getElementById("verifyQRCode").classList.contains("d-none")) {
          document.getElementById("verifyQRCode").classList.remove("d-none");
          setTimeInSeconds(30);
        }
        document.getElementById("regenerateQRCode").classList.add("d-none");
      })
      .catch((error) => {
        console.log(error);
      });

    getQRCode();
  };

  useEffect(() => {
    if (qrCodeUrl && timeInSeconds > 0) {
      const countdownTimer = window.setTimeout(() => {
        setTimeInSeconds(timeInSeconds - 1);
      }, 1000);

      return () => window.clearTimeout(countdownTimer);
    }

    if (timeInSeconds === 0) {
      if (document.getElementById("regenerateQRCode").classList.contains("d-none")) {
        alert("Resend qr code generate request");
        setQrCodeUrl("");
        document.getElementById("regenerateQRCode").classList.remove("d-none");
        document.getElementById("verifyQRCode").classList.add("d-none");
      }
    }
  }, [timeInSeconds, qrCodeUrl]);

  return (
    <div className="row login-start login-page-shell">
      <div className="col-12">
        <div className="login-layout login-layout--centered">
          <section className="login-form-panel login-form-panel--centered auth-flip-card glass-panel setting-login">
            <div className="login-form-header">
              <p className="login-form-eyebrow">Welcome to Allyzent AI</p>
            </div>

            <div className="form-group form-hidden mb-2 py-1 position-relative">
              <label className="login-field-label" htmlFor="userEmail">
                Mail ID
              </label>
              <div className="col-sm-12">
                <input
                  type="email"
                  id="userEmail"
                  onKeyDown={handleKeyDown}
                  className="login-field-input form-control"
                  placeholder="Enter your Registered email address"
                  onFocus={resetErrorFieldStyle}
                />
              </div>
              <small className="pb-2 text-danger position-absolute fs-small login-field-error">
                {emailMessage}
              </small>
            </div>

            <div className="form-group form-hidden mb-2 py-1 position-relative">
              <label className="login-field-label" htmlFor="userPassword">
                Password
              </label>
              <div className="col-sm-12 login-password-field">
                <input
                  type={showPassword ? "text" : "password"}
                  id="userPassword"
                  onKeyDown={handleKeyDown}
                  className="login-field-input form-control"
                  placeholder="Enter your password"
                  onFocus={resetErrorFieldStyle}
                />
                <button
                  type="button"
                  className="login-password-toggle"
                  aria-label={showPassword ? "Hide password" : "Show password"}
                  onClick={() => setShowPassword((value) => !value)}
                >
                  <FontAwesomeIcon icon={faEye} />
                </button>
              </div>
              <small className="pb-2 text-danger position-absolute fs-small login-field-error">
                {passwordMessage}
              </small>
            </div>

            <div className="login-meta-row">
              <button type="button" className="login-forgot-link">
                Forgot password?
              </button>
            </div>

            <div id="qrCodeForm" className="d-none">
              <div className="form-group mb-3 py-1 position-relative">
                <div className="col-sm-12 d-flex justify-content-center align-items-center">
                  <img src={qrCodeUrl} alt="QR Code" className="qrCodeBorder" />
                </div>
                <small className="pb-2 text-danger position-absolute fs-small login-field-error">
                  {passwordMessage}
                </small>
              </div>
              <div className="form-group mb-3 py-1 position-relative">
                <label className="login-field-label" htmlFor="qrCode">
                  Verification code
                </label>
                <div className="col-sm-12">
                  <InputMask
                    mask="9 9 9 9 9 9"
                    id="qrCode"
                    className="login-field-input text-center form-control"
                    placeholder="Enter 6-digit code"
                    onFocus={resetErrorFieldStyle}
                  />
                </div>
                <small className="pb-2 text-danger position-absolute fs-small login-field-error">
                  {qrCodeMessage}
                </small>
              </div>
              <div className="text-center position-relative">
                <button
                  id="verifyQRCode"
                  className="simple-btn login-btn"
                  onClick={verifyQRCodeHandle}
                >
                  Verify{" "}
                  <span className="position-absolute text-right">
                    {timeInSeconds}s
                  </span>
                </button>
              </div>
              <div className="text-center">
                <button
                  id="regenerateQRCode"
                  className="simple-btn login-btn d-none"
                  onClick={regenerateQRCodeHandle}
                >
                  Regenerate QR Code
                </button>
              </div>
            </div>

            <div className="login-action-stack">
              <button
                className="simple-btn login-btn form-hidden login-submit-btn"
                onClick={handleSubmit}
              >
                Login
              </button>
            </div>

            <p className="login-signup-copy">
              Don't have an account?{" "}
              <Link to="/signup" className="login-signup-link">
                Register
              </Link>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};
